import type { AppRouterOutputs } from '@alison/api/router';
import { useClients } from './filters.hooks.js';

export type ClientType = NonNullable<AppRouterOutputs['auth']['currentClient']>['type'];

export const PREFLIGHT_ONLY_HOME = '/flight-check/dashboard';

const PREFLIGHT_ONLY_PREFIXES = [
  PREFLIGHT_ONLY_HOME,
  '/flight-check/analysis',
  '/workflows/preflight',
] as const;

function matchesPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

/** Preflight-only clients are confined to Flight Check; every other type reaches every page. */
export function isAllowedForClient(type: ClientType, pathname: string): boolean {
  if (type !== 'preflight-only') return true;
  return PREFLIGHT_ONLY_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix));
}

/** Null while the client is loading: callers hold anything restricted until it is a boolean. */
export function usePreflightOnly(): boolean | null {
  const clients = useClients();
  if (clients.isPending) return null;
  return clients.data?.[0]?.type === 'preflight-only';
}
